import emptySplitApi from "../utils/rtk";
import { CommonBody, SalaryStructure } from "../types/General";
import { END_POINTS } from "../constants/urls";

type CommonResponseType = {
  status: number;
  message: string;
};
type GetSalaryStructureResponse = {
  length: number;
  start: number;
  response_object: SalaryStructure[];
  total_records: number;
  from_date?: string;
  to_date?: string;
};

export const salaryStructureApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllSalaryStructures: builder.mutation<
      CommonResponseType & { data: GetSalaryStructureResponse },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.allSalaryStructures,
        method: "POST",
        body,
      }),
    }),

    deleteSalaryStructure: builder.query<
      CommonResponseType & { data: SalaryStructure },
      { id: number | null }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSalaryStructure}${id}/`,
        method: "DELETE",
      }),
    }),

    salaryStructureDetail: builder.query<
      CommonResponseType & { data: SalaryStructure | null },
      { id: number }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.salaryStructureDetail}${id}/`,
        method: "GET",
      }),
    }),
    updateSalaryStructure: builder.mutation<
      CommonResponseType & { data: SalaryStructure },
      { body: CommonBody; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSalaryStructure}${id}/`,
        method: "PUT",
        body,
      }),
    }),
    addSalaryStructure: builder.mutation<
      CommonResponseType & { data: SalaryStructure },
      CommonBody
    >({
      query: (body) => ({
        url: END_POINTS.addSalaryStructure,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  useGetAllSalaryStructuresMutation,
  useLazyDeleteSalaryStructureQuery,
  useLazySalaryStructureDetailQuery,
  useAddSalaryStructureMutation,
  useUpdateSalaryStructureMutation,
} = salaryStructureApi;
